/* eslint-disable max-len */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { ProjectDetailInterface } from '../../interfaces/ProjectInterface';
import { getCurrentProjectDetails, updateProjectData } from '../../services/projectServices';
import {
  Container,
  Content,
  Title,
  TaskButton,
  ButtonBlock,
  Options,
  SameIcon,
  Icon,
  DropText,
  ModalHead,
  Headline,
  TaskIcons,
  Filter,
  Data,
  TaskDrop,
  TaskDropdown,
  Status,
  MainContent,
  StarWithTitle,
  ThreeDotIcon,
  ResponsiveContent,
  ResponsiveTopNavbar,
  DIV,
  TaskListName,
  SVGDiv,
  GroupDiv,
  Switch,
  TaskFilterDiv,
  PlusIcon,
  ProjectIconContainer,
  Dropdiv
} from './styles';
import {
  FILES_LIST_TYPE,
  ICON_COLORS,
  MENU_OPTIONS,
  PROJECT_ICON_TYPE,
  SHOW_COMPLETED_TASK_BY_DATE,
  SHOW_COMPLETED_TASK_FILTER_NAME,
  SHOW_TASK_BY_ORDER,
  SHOW_TASK_GROUPING_NAME,
  SHOW_TASK_GROUPING_TYPE,
  SHOW_TASK_ORDER_NAME,
  TASK_LIST_TYPE
} from '../../global/constants';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import DeleteModal from '../models/deleteModel';
import { ROUTES } from '../../routes/urls';
import CreateNewProjectModalV2 from '../models/createNewProjectModal/createProjectModelV2';
import { isEmpty, updateTaskFilterGrouping, updateTaskFilterOrder } from '../../helpers/common';
import ModalCustom from '../models/modal';
import Milestonemodal from '../models/milestoneModal';
import { trackAnalyticActivity } from '../../services/analyticsService';
import { captureException } from '../../services/logService';
import { getWorkspaceProjectPreferenceData, updateWorkspaceProjectPreference } from '../../helpers/firebaseHelper';
import { Location } from 'history';
import { PROJECT_ANALYTICS } from '../../global/analyticsConstants';
import { Dropdown, DropdownItem } from '../Dropdown';
import { completedTaskMenu } from '../../global/row';
import TaskFilterCustomDropdown from '../taskFilterDropdown/taskFilterDropdown';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import CreateTaskModalV2 from '../models/createTaskModal/createTaskModalV2';
import { dispatchAppError } from '../../services/appService';
import { useMobileDevice } from '../../global/useMobile';
import ResponsiveHeader from '../responsiveHeader/header';
import CreateFilesDropdown from '../dropdowns/createFilesDropdown';
import AddIconDropdown from '../viewCard/addIconDropdown';
import ProjectIconAvatar from '../ProjectIconAvtar/projectIconAvtar';

interface Props {
  loadFilesData?: () => void;
  otherTaskList?: () => void;
  loadTaskList?: () => void;
  loadWeekWiseTasks?: () => void;
  isLeftPadding?: boolean;
  setUploadFile?: (value: boolean) => void;
  setUploadedFileDetail?: (item: any) => void;
  isProjectTasks?: boolean;
  onFileUpload?: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  renderDropdownItems?: JSX.Element;
}

const Accounting: React.FC<Props> = (props) => {
  //States
  const [openTaskModel, setOpenTaskModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);
  const [isOpenMilestoneModal, setIsOpenMilestoneModal] = useState(false);
  const [isOpenCreateProjectModal, setIsOpenCreateProjectModal] = useState(false);
  const [isOrderDropdownOpen, setIsOrderDropdownOpen] = useState(false);
  const [isOpenGroupMenu, setIsOpenGroupMenu] = useState(false);
  const [isOpenCompletedTaskDropdown, setIsOpenCompletedTaskDropdown] = useState(false);

  // Mobx store
  const { projectStore, workspaceStore, taskStore, currentUser } = rootStore;
  const { currentProject, createProjectInput, filesViewListType } = projectStore;
  const { taskFilterType: taskFilter } = currentProject || {};
  const { currentWorkspace } = workspaceStore;
  const { name, customerId } = createProjectInput || {};
  const { isTaskFilterOpen } = taskStore;

  //Other variables
  const history = useHistory();
  const params: { id: string } = useParams();
  const location: Location = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMobileDevice();

  const menuItems = [
    { key: 1, label: 'Edit' },
    { key: 3, label: 'Settings' },
    { key: 4, label: 'Archive' }
  ];

  const createTaskModel = useCallback(async () => {
    if (currentProject?.id) {
      rootStore.taskStore.createTaskInput.setProject(currentProject?.id);
      setOpenTaskModel(true);
    }
  }, [currentProject]);

  const loadData = useCallback(
    async (isFalse = false) => {
      if (!isEmpty(currentWorkspace?.id) && (params?.id !== currentProject?.id || isFalse)) {
        if (!props?.isProjectTasks) {
          const projectDetails: ProjectDetailInterface = await dispatch(
            getCurrentProjectDetails(currentWorkspace?.id, params?.id)
          );

          const currentUser = UserPreferenceSingleton.getInstance().getCurrentUser();
          const validUser = projectDetails?.users?.find((user) => user?.id === currentUser?.id);
          if (!validUser) {
            history.push('/');
            return;
          }
        }
      }
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      if (
        currentProject?.id &&
        !currentProject?.priority?.enabled &&
        currentProjectFilter?.order === SHOW_TASK_BY_ORDER.PRIORITY
      ) {
        // Update project order in workspace preference
        await updateWorkspaceProjectPreference(params?.id, {
          tasks_filter_type: { ...(currentProjectFilter || {}), order: SHOW_TASK_BY_ORDER.DUE_DATE }
        });
      }
      const getGroupingType = () => {
        if (currentProject?.statusEnable) return SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS;
        if (currentProject?.isGroupEnabled) return SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP;
        return SHOW_TASK_GROUPING_TYPE.DEFAULT;
      };
      const getOrderType = () => {
        if (currentProjectFilter?.grouping === SHOW_TASK_GROUPING_TYPE.DEFAULT) return SHOW_TASK_BY_ORDER.CUSTOM;
        if (currentProjectFilter?.order === SHOW_TASK_BY_ORDER.CUSTOM) return SHOW_TASK_BY_ORDER.CREATED_DATE;
        return currentProjectFilter?.order || SHOW_TASK_BY_ORDER.CREATED_DATE;
      };
      if (
        (currentProject?.id &&
          currentProjectFilter?.grouping === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_MILESTONE &&
          !currentProject?.isMilestone) ||
        (currentProject?.id &&
          currentProjectFilter?.grouping === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS &&
          (!currentProject?.statusEnable ||
            (currentProject?.statusEnable && currentProject?.statusData?.length === 0))) ||
        (currentProject?.id &&
          currentProjectFilter?.grouping === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_PRIORITY &&
          !currentProject?.priority?.enabled) ||
        (currentProject?.id &&
          currentProjectFilter?.grouping === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP &&
          !currentProject?.isGroupEnabled)
      ) {
        // Update project order and grouping in workspace preference
        await updateWorkspaceProjectPreference(params?.id, {
          tasks_filter_type: { ...(currentProjectFilter || {}), order: getOrderType(), grouping: getGroupingType() }
        });
      }
      const getOrderTypePriority = () => {
        if (
          currentProjectFilter?.viewType === TASK_LIST_TYPE.CALANDAR_VIEW &&
          (currentProjectFilter?.order === SHOW_TASK_BY_ORDER.DUE_DATE || !currentProjectFilter?.order)
        )
          return SHOW_TASK_BY_ORDER.PRIORITY;
        if (currentProjectFilter?.order || currentProjectFilter?.order === 0) return currentProjectFilter.order;
        if (currentProjectFilter?.viewType === TASK_LIST_TYPE.CALANDAR_VIEW) return SHOW_TASK_BY_ORDER.PRIORITY;
        return SHOW_TASK_BY_ORDER.DUE_DATE;
      };
      const updatedProjectFilter = {
        ...currentProjectFilter,
        order: getOrderTypePriority()
      };
      projectStore.setFilesViewListType(updatedProjectFilter?.files || FILES_LIST_TYPE.GRID);
    },
    [
      currentWorkspace?.id,
      params?.id,
      currentProject?.id,
      currentProject?.priority?.enabled,
      currentProject?.isMilestone,
      currentProject?.statusEnable,
      currentProject?.statusData?.length,
      currentProject?.isGroupEnabled,
      dispatch,
      projectStore,
      props?.isProjectTasks,
      history
    ]
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  const isTask = useMemo(() => {
    return location?.pathname === `/projects/details/${params?.id}/tasks`;
  }, [params?.id, location?.pathname]);
  const isFile = useMemo(() => {
    return location?.pathname === `/projects/details/${params?.id}/files`;
  }, [params?.id, location?.pathname]);
  const isMilestone = useMemo(() => {
    return location?.pathname === `/projects/details/${params?.id}/milestone`;
  }, [params?.id, location?.pathname]);
  const isMessages = useMemo(() => {
    return location?.pathname === `/projects/details/${params?.id}/messages`;
  }, [params?.id, location?.pathname]);
  const isOverview = useMemo(() => {
    return location?.pathname === `/projects/details/${params?.id}/overview`;
  }, [params?.id, location?.pathname]);

  const OpenMilestoneModal = () => {
    setIsOpenMilestoneModal(true);
  };

  const isCloseModal = () => {
    setIsOpenMilestoneModal(false);
  };

  const OpenArchiveModel = () => {
    setOpenArchiveModal(true);
  };

  const CloseArchiveModel = () => {
    setOpenArchiveModal(false);
  };

  const closeTaskModel = () => {
    setOpenTaskModel(false);
  };

  const archive = useCallback(async () => {
    try {
      setLoading(true);
      if (!currentWorkspace?.isAdmin) return dispatchAppError(`You can't archive project.`);
      const updatePayload = {
        isArchived: true
      };
      const result = await dispatch(updateProjectData(params?.id, updatePayload));
      if (result) {
        trackAnalyticActivity(PROJECT_ANALYTICS.DELETED);
        history.push(ROUTES.ALL_PROJECT);
      }
    } catch (e) {
      captureException(e);
      console.log('ERROR', e);
    } finally {
      setLoading(false);
    }
  }, [dispatch, history, params?.id, currentWorkspace]);

  const onChangeTaskListType = useCallback(
    async (listType: number) => {
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      const getOrderType = () => {
        if (currentProjectFilter?.order === SHOW_TASK_BY_ORDER.DUE_DATE && listType === TASK_LIST_TYPE.CALANDAR_VIEW)
          return SHOW_TASK_BY_ORDER.PRIORITY;
        if (currentProjectFilter?.order === SHOW_TASK_BY_ORDER.CUSTOM && listType === TASK_LIST_TYPE.CALANDAR_VIEW)
          return SHOW_TASK_BY_ORDER.CREATED_DATE;
        return currentProjectFilter?.order || SHOW_TASK_BY_ORDER.CREATED_DATE;
      };
      const orderType = getOrderType();
      // Update project order and view type in workspace preference
      await updateWorkspaceProjectPreference(params?.id, {
        tasks_filter_type: { ...(currentProjectFilter || {}), order: orderType, viewType: listType }
      });
      currentProject?.updateTaskFilterType('taskViewType', listType || TASK_LIST_TYPE.TASKS);
      currentProject?.updateTaskFilterType('orderByStatus', orderType >= 0 ? orderType : SHOW_TASK_BY_ORDER.DUE_DATE);
      if (props.loadTaskList) props.loadTaskList();
    },
    [currentProject, params?.id, props]
  );

  const openEditProjectModal = useCallback(() => {
    if (!currentProject) return;
    rootStore.projectStore.createProjectInput.updateWith(currentProject);
    setIsOpenCreateProjectModal(true);
  }, [currentProject]);

  const closeEditProjectModal = useCallback(() => {
    setIsOpenCreateProjectModal(false);
    rootStore.projectStore.createProjectInput.clear();
  }, []);

  const CancelModel = useCallback(() => {
    if (!isEmpty(name) || customerId) {
      setConfirmationModalOpen(true);
    } else {
      setIsOpenCreateProjectModal(false);
      rootStore.projectStore.createProjectInput.clear();
    }
  }, [customerId, name]);

  const closeEditModal = () => {
    setConfirmationModalOpen(false);
    setIsOpenCreateProjectModal(false);
    rootStore.projectStore.createProjectInput.clear();
  };

  const closeConfirmationModal = () => {
    setConfirmationModalOpen(false);
    rootStore.projectStore.createProjectInput.clear();
  };

  const handleTaskCompletedByRecency = useCallback(
    async (value: boolean) => {
      currentProject?.updateTaskFilterType('showRecentlyCompletedTask', value);
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      // Update project filter in workspace preference
      await updateWorkspaceProjectPreference(params?.id, {
        tasks_filter_type: { ...(currentProjectFilter || {}), showRecentlyCompletedTask: value }
      });
      if (props.loadTaskList) props.loadTaskList();
    },
    [currentProject, params?.id, props]
  );

  const onChangeCompletedTaskViewDate = useCallback(
    async (key: number | string) => {
      key = Number(key);
      currentProject?.updateTaskFilterType('showCompletedTaskByFilter', key);
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      // Update project filter in workspace preference
      await updateWorkspaceProjectPreference(params?.id, {
        tasks_filter_type: { ...(currentProjectFilter || {}), showCompletedTask: key }
      });
      if (props.loadTaskList) props.loadTaskList();
    },
    [currentProject, params?.id, props]
  );

  const onChangeGroupingFilter = useCallback(
    async (key: string | number) => {
      key = Number(key);
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      const getOrderBasedOnGrouping = () => {
        if (key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP || key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS)
          return SHOW_TASK_BY_ORDER.CUSTOM;
        if (currentProjectFilter?.order === SHOW_TASK_BY_ORDER.CUSTOM) return SHOW_TASK_BY_ORDER.CREATED_DATE;
        return currentProjectFilter?.order || SHOW_TASK_BY_ORDER.CREATED_DATE;
      };
      if (
        key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP ||
        key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS ||
        (key !== SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP &&
          key !== SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS &&
          currentProjectFilter?.order === SHOW_TASK_BY_ORDER.CUSTOM)
      ) {
        currentProject?.updateTaskFilterType(
          'orderByStatus',
          key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP || key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS
            ? SHOW_TASK_BY_ORDER.CUSTOM
            : SHOW_TASK_BY_ORDER.CREATED_DATE
        );
      }
      // Update project grouping and order in workspace preference
      await updateWorkspaceProjectPreference(params?.id, {
        tasks_filter_type: { ...(currentProjectFilter || {}), grouping: key, order: getOrderBasedOnGrouping() }
      });
      currentProject?.updateTaskFilterType(
        'groupingStatus',
        key >= 0 ? key : SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP
      );
      if (key === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS) {
        await handleTaskCompletedByRecency(true);
        await onChangeCompletedTaskViewDate(SHOW_COMPLETED_TASK_BY_DATE.LAST_MONTH);
      }
      if (props?.otherTaskList) props.otherTaskList();
    },
    [currentProject, handleTaskCompletedByRecency, onChangeCompletedTaskViewDate, params?.id, props]
  );

  const onChangeOrderByFilter = useCallback(
    async (key: string | number) => {
      key = Number(key);
      // Get task filter from user preference
      const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
      // Update project order in workspace preference
      await updateWorkspaceProjectPreference(params?.id, {
        tasks_filter_type: { ...(currentProjectFilter || {}), order: key }
      });
      currentProject?.updateTaskFilterType('orderByStatus', key >= 0 ? key : SHOW_TASK_BY_ORDER.DUE_DATE);
      if (props?.otherTaskList) props.otherTaskList();
      if (currentProjectFilter?.viewType === TASK_LIST_TYPE.CALANDAR_VIEW) {
        if (props?.loadWeekWiseTasks) props.loadWeekWiseTasks();
      }
    },
    [currentProject, params?.id, props]
  );

  const onClickProjectSetting = useCallback(() => {
    history.push(`/projects/details/${params?.id}/setting`);
  }, [history, params?.id]);

  const onChangeFilesListType = useCallback(
    async (listType: number) => {
      // await updateWorkspaceProjectPreference(params?.id, { files: listType });
      projectStore.setFilesViewListType(listType);
    },
    [projectStore]
  );

  const handleCheckboxChange = useCallback(async () => {
    const newShowSubTask = !taskFilter?.showSubTask;
    currentProject?.updateTaskFilterType('showSubTask', newShowSubTask);
    // Get task filter from user preference
    const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
    // Update project filter in workspace preference
    await updateWorkspaceProjectPreference(params?.id, {
      tasks_filter_type: { ...(currentProjectFilter || {}), showSubTask: newShowSubTask }
    });
    if (props?.otherTaskList) props.otherTaskList();
  }, [currentProject, params?.id, props, taskFilter?.showSubTask]);

  const handleEmptyGroup = useCallback(async () => {
    const newShowEmptyGroup = !taskFilter?.showEmptyGroup;
    currentProject?.updateTaskFilterType('showEmptyGroup', newShowEmptyGroup);
    // Get task filter from user preference
    const currentProjectFilter = (await getWorkspaceProjectPreferenceData(params?.id, 'tasks_filter_type')) || {};
    // Update project filter in workspace preference
    await updateWorkspaceProjectPreference(params?.id, {
      tasks_filter_type: { ...(currentProjectFilter || {}), showEmptyGroup: newShowEmptyGroup }
    });
  }, [currentProject, params?.id, taskFilter?.showEmptyGroup]);

  const handleClick = useCallback(
    (key: number | string) => {
      key = Number(key);
      if (key === MENU_OPTIONS.EDIT) {
        openEditProjectModal();
      } else if (key === MENU_OPTIONS.SETTING) {
        onClickProjectSetting();
      } else if (key === MENU_OPTIONS.ARCHIVE) {
        OpenArchiveModel();
      }
    },
    [onClickProjectSetting, openEditProjectModal]
  );

  const getGroupName = useCallback(() => {
    const groupingType = updateTaskFilterGrouping(currentProject!);
    return SHOW_TASK_GROUPING_NAME[groupingType];
  }, [currentProject]);

  const getOrderName = useCallback(() => {
    const orderType = updateTaskFilterOrder(currentProject!);
    return SHOW_TASK_ORDER_NAME[orderType];
  }, [currentProject]);

  const renderDropdown = () => {
    return (
      <>
        {menuItems.map((item) => (
          <DropdownItem
            label={item.label}
            key={item?.key}
            tone={item.label === 'Archive' ? 'critical' : 'primary'}
            onClick={() => handleClick(item.key)}
          />
        ))}
      </>
    );
  };

  const groupMenuItems = [
    { key: SHOW_TASK_GROUPING_TYPE.NO_GROUPING, label: 'No Grouping' },
    currentProject?.isGroupEnabled && { key: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP, label: 'Group' },
    currentProject?.priority?.enabled && { key: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_PRIORITY, label: 'Priority' },
    { key: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_USER, label: 'User' },
    currentProject?.isMilestone && { key: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_MILESTONE, label: 'Milestone' },
    currentProject?.statusEnable &&
      currentProject?.statusData?.length > 0 && { key: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS, label: 'Status' }
  ].filter((item): item is { key: number; label: string } => Boolean(item));

  const groupingDropdown = useMemo(() => {
    return groupMenuItems.map((item) => (
      <DropdownItem key={item?.key} label={item.label} onClick={() => onChangeGroupingFilter(item.key)} />
    ));
  }, [groupMenuItems, onChangeGroupingFilter]);

  const onGroupButtonClick = useCallback(() => {
    setIsOpenGroupMenu(!isOpenGroupMenu);
  }, [isOpenGroupMenu]);

  const completedDropdown = useMemo(() => {
    return completedTaskMenu.map((item) => (
      <DropdownItem key={item.key} label={item.label} onClick={() => onChangeCompletedTaskViewDate(item.key)} />
    ));
  }, [onChangeCompletedTaskViewDate]);

  const onTaskButtonClick = useCallback(() => {
    setIsOpenCompletedTaskDropdown(!isOpenCompletedTaskDropdown);
  }, [isOpenCompletedTaskDropdown]);

  // get ordering menu items for filtering
  const orderingMenuItems = useCallback(() => {
    const items = [];

    // Add 'Custom' option if grouping status matches certain types and view type is not 'Calendar View'.
    if (
      (taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS ||
        taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_GROUP ||
        taskFilter?.groupingStatus === SHOW_TASK_GROUPING_TYPE.DEFAULT) &&
      taskFilter?.taskViewType !== TASK_LIST_TYPE.CALANDAR_VIEW
    ) {
      items.push({ key: SHOW_TASK_BY_ORDER.CUSTOM, label: 'Custom' });
    }

    // Add 'Priority' option if priority is enabled.
    if (currentProject?.priority?.enabled) {
      items.push({ key: SHOW_TASK_BY_ORDER.PRIORITY, label: 'Priority' });
    }

    // Add 'Due Date' option if view type is not 'Calendar View'.
    if (taskFilter?.taskViewType !== TASK_LIST_TYPE.CALANDAR_VIEW) {
      items.push({ key: SHOW_TASK_BY_ORDER.DUE_DATE, label: 'Due Date' });
    }

    // Always include 'Created Date'.
    items.push({ key: SHOW_TASK_BY_ORDER.CREATED_DATE, label: 'Created Date' });

    return items;
  }, [currentProject?.priority?.enabled, taskFilter?.groupingStatus, taskFilter?.taskViewType]);

  const orderingMenuDropdown = useMemo(() => {
    const orderingMenuData = orderingMenuItems();
    return orderingMenuData.map((item) => (
      <DropdownItem key={item.key} label={item.label} onClick={() => onChangeOrderByFilter(item.key)} />
    ));
  }, [onChangeOrderByFilter, orderingMenuItems]);

  const onButtonClickOrdering = useCallback(() => {
    setIsOrderDropdownOpen(!isOrderDropdownOpen);
  }, [isOrderDropdownOpen]);

  // isActive prop to control active state
  const renderTaskFilterIcon = (isActive: boolean = false) => (
    <Filter isActive={isActive}>
      <SVGIcon
        name='filters-icon'
        width={isMobile ? '20' : '16'}
        height={isMobile ? '20' : '16'}
        viewBox='0 0 18 18'
        fill='var(--text-secondary)'
      />
    </Filter>
  );

  const renderTaskFilterDropdown = useMemo(() => {
    return (
      <TaskDropdown>
        <TaskDrop isTaskList>
          <Data>
            <Options>
              <SameIcon
                isCardActive={
                  taskFilter?.taskViewType === TASK_LIST_TYPE.TASKS ||
                  isEmpty(taskFilter?.taskViewType) ||
                  !taskFilter?.taskViewType
                }
                onClick={() => onChangeTaskListType(TASK_LIST_TYPE.TASKS)}>
                <DIV>
                  <SVGDiv>
                    <SVGIcon
                      name='three-parallel-line-icon'
                      width='14'
                      height='14'
                      viewBox='0 0 14 14'
                      className='line-fill-color'
                    />
                  </SVGDiv>
                  <TaskListName
                    isCardActive={
                      taskFilter?.taskViewType === TASK_LIST_TYPE.TASKS ||
                      isEmpty(taskFilter?.taskViewType) ||
                      !taskFilter?.taskViewType
                    }>
                    List
                  </TaskListName>
                </DIV>
              </SameIcon>
              <SameIcon
                isCardActive={taskFilter?.taskViewType === TASK_LIST_TYPE.TASK_GRID}
                onClick={() => onChangeTaskListType(TASK_LIST_TYPE.TASK_GRID)}>
                <DIV>
                  <SVGDiv>
                    <SVGIcon name='layout-icon' width='14' height='14' viewBox='0 0 14 14' className='fill-color' />
                  </SVGDiv>
                  <TaskListName isCardActive={taskFilter?.taskViewType === TASK_LIST_TYPE.TASK_GRID}>Grid</TaskListName>
                </DIV>
              </SameIcon>
              <SameIcon
                isCardActive={taskFilter?.taskViewType === TASK_LIST_TYPE.CALANDAR_VIEW}
                onClick={() => onChangeTaskListType(TASK_LIST_TYPE.CALANDAR_VIEW)}>
                <DIV>
                  <SVGDiv>
                    <SVGIcon
                      name='calendar-icon'
                      width='14'
                      height='14'
                      viewBox='0 0 18 18'
                      className='calendar-fill-color'
                    />
                  </SVGDiv>
                  <TaskListName isCardActive={taskFilter?.taskViewType === TASK_LIST_TYPE.CALANDAR_VIEW}>
                    Calendar
                  </TaskListName>
                </DIV>
              </SameIcon>
            </Options>
          </Data>
          <TaskFilterDiv>
            {taskFilter?.taskViewType !== TASK_LIST_TYPE.CALANDAR_VIEW && (
              <Data>
                <GroupDiv>
                  <SVGDiv>
                    <SVGIcon name='group-icon' width='14' height='14' viewBox='0 0 16 16' fill='none' />
                  </SVGDiv>
                  <DropText>Grouping</DropText>
                </GroupDiv>
                <Dropdown
                  modalTitle='Grouping'
                  content={
                    <Status onClick={onGroupButtonClick}>
                      <p>{getGroupName()}</p>
                      <SVGIcon
                        name='dropdown-icon'
                        width='20'
                        height='20'
                        viewBox='0 0 24 24'
                        fill='none'
                        className={isOpenGroupMenu ? 'dropdown-icon fill-color' : 'fill-color'}
                      />
                    </Status>
                  }
                  trigger='click'>
                  {groupingDropdown}
                </Dropdown>
              </Data>
            )}
            <Data>
              <GroupDiv>
                <SVGDiv>
                  <SVGIcon
                    name='small-filters-icon'
                    width='14'
                    height='14'
                    viewBox='0 0 14 14'
                    className='filters-icon-color'
                  />
                </SVGDiv>
                <DropText>Ordering</DropText>
              </GroupDiv>
              <Dropdown
                modalTitle='Ordering'
                content={
                  <Status onClick={onButtonClickOrdering}>
                    <p>{getOrderName()}</p>
                    <SVGIcon
                      name='dropdown-icon'
                      width='20'
                      height='20'
                      viewBox='0 0 24 24'
                      fill='none'
                      className={isOrderDropdownOpen ? 'dropdown-icon fill-color' : 'fill-color'}
                    />
                  </Status>
                }
                trigger='click'>
                {orderingMenuDropdown}
              </Dropdown>
            </Data>
          </TaskFilterDiv>
        </TaskDrop>
        <TaskFilterDiv>
          {currentProject &&
            updateTaskFilterGrouping(currentProject) === SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS && (
              <TaskDrop isTaskList>
                <Data>
                  <GroupDiv>
                    <DropText>Task completed by recency</DropText>
                  </GroupDiv>
                  <Switch>
                    <label className='switch'>
                      <input
                        type='checkbox'
                        checked={taskFilter?.showRecentlyCompletedTask}
                        onChange={() => handleTaskCompletedByRecency(!taskFilter?.showRecentlyCompletedTask)}
                      />
                      <span className='slider round'></span>
                    </label>
                  </Switch>
                </Data>
                {taskFilter?.taskViewType !== TASK_LIST_TYPE.CALANDAR_VIEW && (
                  <Data>
                    <GroupDiv>
                      <DropText>Completed tasks</DropText>
                    </GroupDiv>

                    <Dropdown
                      modalTitle='Completed tasks'
                      content={
                        <Status onClick={onTaskButtonClick}>
                          <p>
                            {
                              SHOW_COMPLETED_TASK_FILTER_NAME[
                                taskFilter?.showCompletedTaskByFilter || SHOW_COMPLETED_TASK_BY_DATE.LAST_MONTH
                              ]
                            }
                          </p>
                          <SVGIcon
                            name='dropdown-icon'
                            width='20'
                            height='20'
                            viewBox='0 0 24 24'
                            fill='none'
                            className={isOpenCompletedTaskDropdown ? 'dropdown-icon fill-color' : 'fill-color'}
                          />
                        </Status>
                      }>
                      {completedDropdown}
                    </Dropdown>
                  </Data>
                )}
              </TaskDrop>
            )}
          <TaskDrop>
            <Data>
              <GroupDiv>
                <DropText>Show sub-tasks</DropText>
              </GroupDiv>
              <Switch>
                <label className='switch'>
                  <input type='checkbox' checked={taskFilter?.showSubTask} onChange={handleCheckboxChange} />
                  <span className='slider round'></span>
                </label>
              </Switch>
            </Data>
            {taskFilter?.taskViewType !== TASK_LIST_TYPE.CALANDAR_VIEW && (
              <Data>
                <GroupDiv>
                  <DropText>Show empty groups</DropText>
                </GroupDiv>
                <Switch>
                  <label className='switch'>
                    <input type='checkbox' checked={taskFilter?.showEmptyGroup} onChange={handleEmptyGroup} />
                    <span className='slider round'></span>
                  </label>
                </Switch>
              </Data>
            )}
          </TaskDrop>
        </TaskFilterDiv>
      </TaskDropdown>
    );
  }, [
    completedDropdown,
    currentProject,
    getGroupName,
    getOrderName,
    groupingDropdown,
    handleCheckboxChange,
    handleEmptyGroup,
    handleTaskCompletedByRecency,
    isOpenCompletedTaskDropdown,
    isOpenGroupMenu,
    isOrderDropdownOpen,
    onButtonClickOrdering,
    onChangeTaskListType,
    onGroupButtonClick,
    onTaskButtonClick,
    orderingMenuDropdown,
    taskFilter?.showCompletedTaskByFilter,
    taskFilter?.showEmptyGroup,
    taskFilter?.showRecentlyCompletedTask,
    taskFilter?.showSubTask,
    taskFilter?.taskViewType
  ]);

  const renderFileFilterDropdown = useMemo(() => {
    return (
      <TaskDropdown>
        <TaskDrop isWidth={true}>
          <Data>
            <Options>
              <SameIcon
                className='files-filter'
                isCardActive={filesViewListType === FILES_LIST_TYPE.GRID || isEmpty(filesViewListType)}
                onClick={() => onChangeFilesListType(FILES_LIST_TYPE.GRID)}>
                <DIV>
                  <SVGDiv>
                    <SVGIcon name='layout-icon' width='14' height='14' viewBox='0 0 14 14' className='fill-color' />
                  </SVGDiv>
                  <TaskListName isCardActive={filesViewListType === FILES_LIST_TYPE.GRID || isEmpty(filesViewListType)}>
                    Grid
                  </TaskListName>
                </DIV>
              </SameIcon>
              <SameIcon
                className='files-filter'
                isCardActive={filesViewListType === FILES_LIST_TYPE.LIST}
                onClick={() => onChangeFilesListType(FILES_LIST_TYPE.LIST)}>
                <DIV>
                  <SVGDiv>
                    <SVGIcon
                      name='three-parallel-line-icon'
                      width='14'
                      height='14'
                      viewBox='0 0 14 14'
                      className='line-fill-color'
                    />
                  </SVGDiv>
                  <TaskListName isCardActive={filesViewListType === FILES_LIST_TYPE.LIST}>List</TaskListName>
                </DIV>
              </SameIcon>
            </Options>
          </Data>
        </TaskDrop>
      </TaskDropdown>
    );
  }, [filesViewListType, onChangeFilesListType]);

  return (
    <>
      {isMobile && (
        <ResponsiveHeader
          applyDottedText={true}
          Title={currentProject?.name || ''}
          isProjectDetail={true}
          leftElement={
            (isTask || isFile) && (
              <TaskFilterCustomDropdown
                trigger={renderTaskFilterIcon}
                isTaskFilterOpen={isTask && isTaskFilterOpen}
                content={isFile ? renderFileFilterDropdown : isTask ? renderTaskFilterDropdown : ''}
                isMinWidth={isFile ? 168 : 247}
              />
            )
          }
        />
      )}
      <MainContent>
        <Container>
          <Content>
            {!isMobile && (
              <ProjectIconContainer>
                {currentUser?.isAdmin || currentUser?.isOwner ? (
                  <AddIconDropdown currentProject={currentProject!} />
                ) : (
                  <ProjectIconAvatar
                    size={isMobile ? 30 : 26}
                    type={currentProject?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
                    reference={currentProject?.icon?.reference || ''}
                    backgroundColor={currentProject?.icon?.color ? ICON_COLORS[currentProject?.icon?.color] : ''}
                    projectName={currentProject?.name || ''}
                    iconSize={16}
                    isClickable={false}
                  />
                )}
                <StarWithTitle>
                  {!window.location.hostname.startsWith('embed') && (
                    <Title className='web'>{currentProject?.name}</Title>
                  )}
                </StarWithTitle>
              </ProjectIconContainer>
            )}
            <ButtonBlock>
              {isEmpty(currentWorkspace?.customerId) && !currentWorkspace?.customerRole && (
                <TaskButton
                  isActive={isOverview}
                  onClick={() => history.push(`/projects/details/${params?.id}/overview`)}>
                  Overview
                </TaskButton>
              )}
              <TaskButton isActive={isTask} onClick={() => history.push(`/projects/details/${params?.id}/tasks`)}>
                Tasks
              </TaskButton>
              {currentProject?.isMilestone && (
                <TaskButton
                  isActive={isMilestone}
                  onClick={() => history.push(`/projects/details/${params?.id}/milestone`)}>
                  Milestones
                </TaskButton>
              )}
              <TaskButton isActive={isFile} onClick={() => history.push(`/projects/details/${params?.id}/files`)}>
                Files
              </TaskButton>
              <TaskButton
                isActive={isMessages}
                onClick={() => history.push(`/projects/details/${params?.id}/messages`)}>
                Messages
              </TaskButton>
              {(currentWorkspace?.isAdmin || currentWorkspace?.isOwner) && (
                <Dropdiv>
                  <Dropdown
                    modalTitle='More'
                    activeClassName='active-state'
                    content={
                      <ThreeDotIcon>
                        <SVGIcon
                          name='three-dots-horizontal-icon'
                          width='16'
                          height='16'
                          viewBox='0 0 18 18'
                          fill='var(--text-secondary)'
                        />
                      </ThreeDotIcon>
                    }
                    trigger='click'>
                    {renderDropdown()}
                  </Dropdown>
                </Dropdiv>
              )}
            </ButtonBlock>
          </Content>
          {!isMobile && (
            <ResponsiveContent>
              <ResponsiveTopNavbar>
                {isTask && (
                  <>
                    <TaskIcons>
                      <TaskFilterCustomDropdown
                        trigger={renderTaskFilterIcon}
                        isTaskFilterOpen={isTaskFilterOpen}
                        content={renderTaskFilterDropdown}
                      />
                      <PlusIcon onClick={createTaskModel}>
                        <SVGIcon name='plus-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-white)' />
                      </PlusIcon>
                    </TaskIcons>
                  </>
                )}

                {isFile && (
                  <TaskIcons>
                    <TaskFilterCustomDropdown
                      trigger={renderTaskFilterIcon}
                      content={renderFileFilterDropdown}
                      isMinWidth={168}
                    />
                    <CreateFilesDropdown
                      onFileUpload={props?.onFileUpload}
                      renderDropdownItems={props?.renderDropdownItems}
                    />
                  </TaskIcons>
                )}

                {isMilestone && (
                  <PlusIcon onClick={OpenMilestoneModal}>
                    <SVGIcon name='plus-icon' width='20' height='20' viewBox='0 0 18 18' fill='var(--text-white)' />
                  </PlusIcon>
                )}
              </ResponsiveTopNavbar>
            </ResponsiveContent>
          )}
        </Container>
      </MainContent>
      <ModalCustom open={openTaskModel} onClose={closeTaskModel} isCreateTask={true}>
        <CreateTaskModalV2 loadData={props?.loadTaskList} onCancel={closeTaskModel} />
      </ModalCustom>
      <ModalCustom open={openArchiveModal} onClose={CloseArchiveModel} width={334}>
        <DeleteModal
          onClose={CloseArchiveModel}
          onOk={archive}
          isArchive={true}
          loading={loading}
          modalTitle='Archive Project'
          description='Confirming archive? You can restore it later if needed.'
        />
      </ModalCustom>
      <ModalCustom open={isOpenCreateProjectModal} onClose={CancelModel} width={632}>
        <ModalHead>
          <Headline>Edit Project</Headline>
          <Icon onClick={CancelModel}>
            <SVGIcon
              name='close-icon'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              stroke='var(--text-primary)'
              className='close-icon'
            />
          </Icon>
        </ModalHead>
        <CreateNewProjectModalV2
          handleCloseModal={closeEditProjectModal}
          onClickCancel={CancelModel}
          loadProjectData={() => loadData(true)}
        />
      </ModalCustom>
      <ModalCustom width={462} open={isOpenMilestoneModal} onClose={isCloseModal}>
        <Milestonemodal onClose={isCloseModal} projectId={params?.id} />
      </ModalCustom>
      <ModalCustom open={confirmationModalOpen} onClose={() => setConfirmationModalOpen(false)} width={334}>
        <DeleteModal
          isYes={true}
          onClose={closeConfirmationModal}
          onOk={closeEditModal}
          modalTitle='Confirmation Model'
          description='Are you sure you want close this model?'
        />
      </ModalCustom>
    </>
  );
};
export default observer(Accounting);
